export const GET_PRICETYPE_DATA = 'GET_PRICETYPE_RESULT_DETAILS';
export const POST_PRICETYPE_DATA = 'POST_PRICETYPE_RESULT_DETAILS';

export const COMPARE_PRICE_TYPE_DATA = 'COMPARE_PRICE_TYPE_DATA';

export const PRICE_TYPE_DATA_LOADING = 'PRICE_TYPE_DATA_LOADING';
export const PRICE_TYPE_DATA_CHANGE_TRIED = 'PRICE_TYPE_DATA_CHANGE_TRIED';
export const PRICE_TYPE_ERROR_MESSAGE = 'PRICE_TYPE_ERROR_MESSAGE';
export const PRICE_TYPE_SUCCESS_MESSAGE = 'PRICE_TYPE_SUCCESS_MESSAGE';
export const RESET_PRICETYPE_STORE = 'RESET_PRICETYPE_STORE';
